export default __webpack_public_path__ + "static/media/himanshuPIC1.61d5c954.jpg";